export const mockVehicles = [
    {
        id: 'veh-1',
        vehicleNumber: 'A234PA77',
        vehicleType: 'Реф 20т',
        carrierName: 'Итеко',
        driverFullName: 'Селиванов Виктор Сергеевич',
        driverPhone: '89239000012',
        activeShippingDate: '15.04.2025 10:30',
        tasksCount: 6,
    },
    {
        id: 'veh-2',
        vehicleNumber: 'B987OP77',
        vehicleType: 'Тент 10т',
        carrierName: 'Деловые линии',
        driverFullName: 'Морозов Иван Петрович',
        driverPhone: '89161234567',
        activeShippingDate: '16.04.2025 08:00',
        tasksCount: 8,
    },
    {
        id: 'veh-3',
        vehicleNumber: 'M456XY99',
        vehicleType: 'Изотерм',
        carrierName: 'ПЭК',
        driverFullName: 'Петров Николай Андреевич',
        driverPhone: '89170001122',
        activeShippingDate: '17.04.2025 13:15',
        tasksCount: 4,
    },
  ];
  
  export const mockTasksByVehicleId = {
    'veh-1': [
        {
            id: 'task-1-1',
            number: 1,
            shippingNumber: '5014492',
            shippingStatus: 'shippingConfirmed',
            shippingCity: 'Москва',
            deliveryCity: 'Казань',
            shippingDate: '15.04.2025 11:00',
            deliveryDate: '16.04.2025 18:00',
            distance: 820,
            homeplantDistance: 210,
        },
        {
            id: 'task-1-2',
            number: 2,
            shippingNumber: '5014493',
            shippingStatus: 'shippingCompleted',
            shippingCity: 'Москва',
            deliveryCity: 'Тула',
            shippingDate: '15.04.2025 13:00',
            deliveryDate: '15.04.2025 18:00',
            distance: 180,
            homeplantDistance: 70,
        },
        {
            id: 'task-1-3',
            number: 3,
            shippingNumber: '5014494',
            shippingStatus: 'delivered',
            shippingCity: 'Москва',
            deliveryCity: 'Ярославль',
            shippingDate: '14.04.2025 09:00',
            deliveryDate: '14.04.2025 15:00',
            distance: 260,
            homeplantDistance: 90,
        },
        {
            id: 'task-1-4',
            number: 4,
            shippingNumber: '5014495',
            shippingStatus: 'shippingConfirmed',
            shippingCity: 'Москва',
            deliveryCity: 'Нижний Новгород',
            shippingDate: '15.04.2025 16:00',
            deliveryDate: '16.04.2025 06:00',
            distance: 450,
            homeplantDistance: 120,
        },
        {
            id: 'task-1-5',
            number: 5,
            shippingNumber: '5014496',
            shippingStatus: 'shippingCompleted',
            shippingCity: 'Москва',
            deliveryCity: 'Воронеж',
            shippingDate: '15.04.2025 20:00',
            deliveryDate: '16.04.2025 10:00',
            distance: 530,
            homeplantDistance: 150,
        },
        {
            id: 'task-1-6',
            number: 6,
            shippingNumber: '5014497',
            shippingStatus: 'delivered',
            shippingCity: 'Москва',
            deliveryCity: 'Саратов',
            shippingDate: '14.04.2025 06:00',
            deliveryDate: '14.04.2025 12:00',
            distance: 360,
            homeplantDistance: 80,
        },
    ],
    'veh-2': [
        {
            id: 'task-2-1',
            number: 1,
            shippingNumber: '6012345',
            shippingStatus: 'shippingConfirmed',
            shippingCity: 'Санкт-Петербург',
            deliveryCity: 'Псков',
            shippingDate: '16.04.2025 09:00',
            deliveryDate: '16.04.2025 16:00',
            distance: 300,
            homeplantDistance: 50,
        },
        {
            id: 'task-2-2',
            number: 2,
            shippingNumber: '6012346',
            shippingStatus: 'shippingCompleted',
            shippingCity: 'Псков',
            deliveryCity: 'Новгород',
            shippingDate: '16.04.2025 17:00',
            deliveryDate: '16.04.2025 22:00',
            distance: 250,
            homeplantDistance: 40,
        },
        {
            id: 'task-2-3',
            number: 3,
            shippingNumber: '6012347',
            shippingStatus: 'shippingConfirmed',
            shippingCity: 'Санкт-Петербург',
            deliveryCity: 'Тверь',
            shippingDate: '16.04.2025 20:00',
            deliveryDate: '17.04.2025 06:00',
            distance: 200,
            homeplantDistance: 60,
        },
        {
            id: 'task-2-4',
            number: 4,
            shippingNumber: '6012348',
            shippingStatus: 'delivered',
            shippingCity: 'Тверь',
            deliveryCity: 'Москва',
            shippingDate: '17.04.2025 01:00',
            deliveryDate: '17.04.2025 10:00',
            distance: 150,
            homeplantDistance: 30,
        },
        {
            id: 'task-2-5',
            number: 5,
            shippingNumber: '6012349',
            shippingStatus: 'delivered',
            shippingCity: 'Москва',
            deliveryCity: 'Ярославль',
            shippingDate: '17.04.2025 07:00',
            deliveryDate: '17.04.2025 12:00',
            distance: 450,
            homeplantDistance: 100,
        },
        {
            id: 'task-2-6',
            number: 6,
            shippingNumber: '6012350',
            shippingStatus: 'shippingConfirmed',
            shippingCity: 'Москва',
            deliveryCity: 'Ростов-на-Дону',
            shippingDate: '17.04.2025 10:00',
            deliveryDate: '17.04.2025 18:00',
            distance: 800,
            homeplantDistance: 180,
        },
        {
            id: 'task-2-7',
            number: 7,
            shippingNumber: '6012351',
            shippingStatus: 'shippingConfirmed',
            shippingCity: 'Ростов-на-Дону',
            deliveryCity: 'Волгоград',
            shippingDate: '17.04.2025 12:00',
            deliveryDate: '17.04.2025 20:00',
            distance: 320,
            homeplantDistance: 75,
        },
        {
            id: 'task-2-8',
            number: 8,
            shippingNumber: '6012352',
            shippingStatus: 'delivered',
            shippingCity: 'Волгоград',
            deliveryCity: 'Казань',
            shippingDate: '17.04.2025 14:00',
            deliveryDate: '17.04.2025 22:00',
            distance: 500,
            homeplantDistance: 90,
        },
    ],
    'veh-3': [
        {
            id: 'task-3-1',
            number: 1,
            shippingNumber: '7019876',
            shippingStatus: 'shippingConfirmed',
            shippingCity: 'Екатеринбург',
            deliveryCity: 'Пермь',
            shippingDate: '17.04.2025 14:00',
            deliveryDate: '17.04.2025 20:00',
            distance: 360,
            homeplantDistance: 60,
        },
        {
            id: 'task-3-2',
            number: 2,
            shippingNumber: '7019877',
            shippingStatus: 'delivered',
            shippingCity: 'Екатеринбург',
            deliveryCity: 'Челябинск',
            shippingDate: '17.04.2025 16:00',
            deliveryDate: '17.04.2025 22:00',
            distance: 150,
            homeplantDistance: 40,
        },
        {
            id: 'task-3-3',
            number: 3,
            shippingNumber: '7019878',
            shippingStatus: 'delivered',
            shippingCity: 'Челябинск',
            deliveryCity: 'Оренбург',
            shippingDate: '17.04.2025 18:00',
            deliveryDate: '17.04.2025 23:00',
            distance: 450,
            homeplantDistance: 110,
        },
        {
            id: 'task-3-4',
            number: 4,
            shippingNumber: '7019879',
            shippingStatus: 'shippingConfirmed',
            shippingCity: 'Оренбург',
            deliveryCity: 'Самара',
            shippingDate: '17.04.2025 20:00',
            deliveryDate: '18.04.2025 08:00',
            distance: 330,
            homeplantDistance: 80,
        },
    ],
  };
  
  export const mockSearchResults = [
    {
        directionId: 'dir-1',
        priority: 1,
        isPriority: true,
        shippingStatus: 'shippingConfirmed',
        shippingCity: 'Москва',
        deliveryCity: 'Казань',
        shippingsCount: 4,
        vehicleId: "veh-1",
        shippings: [
            {
                shippingId: "1",
                shippingNumber: '5014492',
                shippingStatus: 'shippingConfirmed',
                vehicleType: 'Реф 20т',
                ShippingZoneId: 'zone-1',
                DeliveryZoneId: 'zone-2',
                shippingCity: 'Москва',
                deliveryCity: 'Казань',
                shippingDate: '18.04.2025 10:00',
                deliveryDate: '19.04.2025 18:00',
                deliveryAddress: 'Казань, ул Победы, д 5',
            },
            {
                shippingId: "2",
                shippingNumber: '5014498',
                shippingStatus: 'shippingConfirmed',
                vehicleType: 'Реф 20т',
                ShippingZoneId: 'zone-1',
                DeliveryZoneId: 'zone-2',
                shippingCity: 'Москва',
                deliveryCity: 'Казань',
                shippingDate: '18.04.2025 15:00',
                deliveryDate: '19.04.2025 23:00',
                deliveryAddress: 'Казань, ул Мусы Джалиля, д 3',
            },
            {
                shippingId: "3",
                shippingNumber: '5014499',
                shippingStatus: 'shippingConfirmed',
                vehicleType: 'Реф 20т',
                ShippingZoneId: 'zone-1',
                DeliveryZoneId: 'zone-2',
                shippingCity: 'Москва',
                deliveryCity: 'Казань',
                shippingDate: '19.04.2025 12:00',
                deliveryDate: '20.04.2025 08:00',
                deliveryAddress: 'Казань, ул Воровского, д 12',
            },
            {
                shippingId: "4",
                shippingNumber: '5014500',
                shippingStatus: 'shippingConfirmed',
                vehicleType: 'Реф 20т',
                ShippingZoneId: 'zone-1',
                DeliveryZoneId: 'zone-2',
                shippingCity: 'Москва',
                deliveryCity: 'Казань',
                shippingDate: '19.04.2025 18:00',
                deliveryDate: '20.04.2025 10:00',
                deliveryAddress: 'Казань, ул Чкалова, д 15',
            },
        ],
    },
    {
        directionId: 'dir-2',
        priority: 2,
        isPriority: false,
        shippingStatus: 'shippingConfirmed',
        shippingCity: 'Санкт-Петербург',
        deliveryCity: 'Новгород',
        shippingsCount: 3,
        vehicleId: "veh-2",
        shippings: [
            {
                shippingId: "5",
                shippingNumber: '6012347',
                shippingStatus: 'shippingConfirmed',
                vehicleType: 'Тент 10т',
                ShippingZoneId: 'zone-3',
                DeliveryZoneId: 'zone-4',
                shippingCity: 'Санкт-Петербург',
                deliveryCity: 'Новгород',
                shippingDate: '18.04.2025 08:00',
                deliveryDate: '18.04.2025 14:00',
                deliveryAddress: 'Новгород, пр Ленина, д 1',
            },
            {
                shippingId: "6",
                shippingNumber: '6012348',
                shippingStatus: 'shippingConfirmed',
                vehicleType: 'Тент 10т',
                ShippingZoneId: 'zone-3',
                DeliveryZoneId: 'zone-4',
                shippingCity: 'Санкт-Петербург',
                deliveryCity: 'Новгород',
                shippingDate: '18.04.2025 15:00',
                deliveryDate: '18.04.2025 21:00',
                deliveryAddress: 'Новгород, ул Советская, д 10',
            },
            {
                shippingId: "7",
                shippingNumber: '6012349',
                shippingStatus: 'shippingConfirmed',
                vehicleType: 'Тент 10т',
                ShippingZoneId: 'zone-3',
                DeliveryZoneId: 'zone-4',
                shippingCity: 'Санкт-Петербург',
                deliveryCity: 'Новгород',
                shippingDate: '18.04.2025 17:00',
                deliveryDate: '18.04.2025 22:00',
                deliveryAddress: 'Новгород, ул Ленина, д 3',
            },
        ],
    },
    {
        directionId: 'dir-3',
        priority: 1,
        isPriority: true,
        shippingStatus: 'delivered',
        shippingCity: 'Санкт-Петербург',
        deliveryCity: 'Нижний Новгород',
        shippingsCount: 3,
        vehicleId: "veh-3",
        shippings: [
            {
                shippingId: "8",
                shippingNumber: '6011234',
                shippingStatus: 'delivered',
                vehicleType: 'Тент 10т',
                ShippingZoneId: 'zone-3',
                DeliveryZoneId: 'zone-4',
                shippingCity: 'Санкт-Петербург',
                deliveryCity: 'Нижний Новгород',
                shippingDate: '18.04.2025 08:00',
                deliveryDate: '19.04.2025 14:00',
                deliveryAddress: 'Нижний Новгород, пр-т Ленина, д 45',
            },
            {
                shippingId: "9",
                shippingNumber: '6011235',
                shippingStatus: 'delivered',
                vehicleType: 'Тент 10т',
                ShippingZoneId: 'zone-3',
                DeliveryZoneId: 'zone-4',
                shippingCity: 'Санкт-Петербург',
                deliveryCity: 'Нижний Новгород',
                shippingDate: '18.04.2025 12:00',
                deliveryDate: '19.04.2025 18:00',
                deliveryAddress: 'Нижний Новгород, ул Гоголя, д 7',
            },
            {
                shippingId: "10",
                shippingNumber: '6011236',
                shippingStatus: 'delivered',
                vehicleType: 'Тент 10т',
                ShippingZoneId: 'zone-3',
                DeliveryZoneId: 'zone-4',
                shippingCity: 'Санкт-Петербург',
                deliveryCity: 'Нижний Новгород',
                shippingDate: '18.04.2025 17:00',
                deliveryDate: '20.04.2025 08:00',
                deliveryAddress: 'Нижний Новгород, ул Свободы, д 11',
            },
        ],
    },
    {
        directionId: 'dir-4',
        priority: 2,
        isPriority: true,
        shippingStatus: 'shippingDraft',
        shippingCity: 'Екатеринбург',
        deliveryCity: 'Тюмень',
        shippingsCount: 2,
        vehicleId: "veh-3",
        shippings: [
            {
                shippingId: "11",
                shippingNumber: '7015577',
                shippingStatus: 'shippingDraft',
                vehicleType: 'Борт 5т',
                ShippingZoneId: 'zone-5',
                DeliveryZoneId: 'zone-6',
                shippingCity: 'Екатеринбург',
                deliveryCity: 'Тюмень',
                shippingDate: '20.04.2025 09:00',
                deliveryDate: '20.04.2025 18:00',
                deliveryAddress: 'Тюмень, ул Республики, д 22',
            },
            {
                shippingId: "12",
                shippingNumber: '7015578',
                shippingStatus: 'shippingDraft',
                vehicleType: 'Борт 5т',
                ShippingZoneId: 'zone-5',
                DeliveryZoneId: 'zone-6',
                shippingCity: 'Екатеринбург',
                deliveryCity: 'Тюмень',
                shippingDate: '20.04.2025 13:00',
                deliveryDate: '20.04.2025 20:00',
                deliveryAddress: 'Тюмень, ул Мельникайте, д 10',
            },
        ],
    },
    {
        directionId: 'dir-5',
        priority: 3,
        isPriority: true,
        shippingStatus: 'shippingConfirmed',
        shippingCity: 'Новосибирск',
        deliveryCity: 'Барнаул',
        shippingsCount: 3,
        vehicleId: "veh-3",
        shippings: [
            {
                shippingId: "13",
                shippingNumber: '8016781',
                shippingStatus: 'shippingConfirmed',
                vehicleType: 'Изотерм 3т',
                ShippingZoneId: 'zone-7',
                DeliveryZoneId: 'zone-8',
                shippingCity: 'Новосибирск',
                deliveryCity: 'Барнаул',
                shippingDate: '19.04.2025 07:00',
                deliveryDate: '19.04.2025 15:00',
                deliveryAddress: 'Барнаул, ул Малахова, д 2',
            },
            {
                shippingId: "14",
                shippingNumber: '8016782',
                shippingStatus: 'shippingConfirmed',
                vehicleType: 'Изотерм 3т',
                ShippingZoneId: 'zone-7',
                DeliveryZoneId: 'zone-8',
                shippingCity: 'Новосибирск',
                deliveryCity: 'Барнаул',
                shippingDate: '19.04.2025 11:00',
                deliveryDate: '19.04.2025 17:00',
                deliveryAddress: 'Барнаул, ул Георгиева, д 18',
            },
            {
                shippingId: "15",
                shippingNumber: '8016783',
                shippingStatus: 'shippingConfirmed',
                vehicleType: 'Изотерм 3т',
                ShippingZoneId: 'zone-7',
                DeliveryZoneId: 'zone-8',
                shippingCity: 'Новосибирск',
                deliveryCity: 'Барнаул',
                shippingDate: '19.04.2025 13:00',
                deliveryDate: '19.04.2025 20:00',
                deliveryAddress: 'Барнаул, ул Попова, д 33',
            },
        ],
    },
    {
        directionId: 'dir-6',
        priority: 4,
        isPriority: false,
        shippingStatus: 'delivered',
        shippingCity: 'Краснодар',
        deliveryCity: 'Ростов-на-Дону',
        shippingsCount: 2,
        vehicleId: "veh-3",
        shippings: [
            {
                shippingId: "16",
                shippingNumber: '9013456',
                shippingStatus: 'delivered',
                vehicleType: 'Фургон 10т',
                ShippingZoneId: 'zone-9',
                DeliveryZoneId: 'zone-10',
                shippingCity: 'Краснодар',
                deliveryCity: 'Ростов-на-Дону',
                shippingDate: '20.04.2025 10:00',
                deliveryDate: '20.04.2025 17:00',
                deliveryAddress: 'Ростов-на-Дону, ул Ленина, д 101',
            },
            {
                shippingId: "17",
                shippingNumber: '9013457',
                shippingStatus: 'delivered',
                vehicleType: 'Фургон 10т',
                ShippingZoneId: 'zone-9',
                DeliveryZoneId: 'zone-10',
                shippingCity: 'Краснодар',
                deliveryCity: 'Ростов-на-Дону',
                shippingDate: '20.04.2025 14:00',
                deliveryDate: '20.04.2025 20:00',
                deliveryAddress: 'Ростов-на-Дону, пр-т Стачки, д 50',
            },
        ],
    }
  ];
  export const mockCancelResult = {
    isError: false,
    message: 'Отменено 1 задание',
  };

  export const mockAssignResult = {
    isError: false,
    message: 'Направление назначено',
  };